import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack } from '@tq/ui-components';

import { ActionMenuButton, AssigneeDetails, PageHeading } from 'components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { Consultation } from 'types';
import { useDetailsMenuOptions } from '../../hooks';

export interface DetailsHeaderProps {
  consultation: Consultation | undefined;
}

export const CaseDetailsHeader: React.FC<DetailsHeaderProps> = ({ consultation }) => {
  const { t } = useTranslation('case_details_header');
  const options = useDetailsMenuOptions(consultation);
  const isMobile = useIsMobile();
  const actionButton = (
    <ActionMenuButton consultationId={consultation?.id} options={options} />
  );
  return (
    <>
      <HStack justifyContent='space-between' spacing={4}>
        <PageHeading
          heading={
            consultation?.isArchived
              ? t('case_details_archived', 'Case details (Archived)')
              : t('case_details', 'Case details')
          }
        />
        {!isMobile && actionButton}
      </HStack>
      <AssigneeDetails topPadding={false} showFooter={false} />
      {isMobile && <Box mt={4}>{actionButton}</Box>}
    </>
  );
};
